import PageShell from "../components/PageShell";

/** Every unmatched URL on the site. */
const NotFound = () => (
  <PageShell>
    <main className="station">
      <p className="eyebrow">
        <span className="blip" /> 404
      </p>
      <h1 className="station__name">Dead air.</h1>
      <p className="station__sub">
        There's nothing at this address. The link may be mistyped, or whatever
        lived here has moved on.
      </p>
      <a className="btn" href="/">
        Back to StreamLover
      </a>
    </main>
  </PageShell>
);

export default NotFound;
